import { render, staticRenderFns } from "./FriendCard.vue?vue&type=template&id=19ee9bb4&"
import script from "./FriendCard.vue?vue&type=script&lang=js&"
export * from "./FriendCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports